<template>
  <main id="content">
    <!-- Banner Area Start -->
    <section class="banner-area text-left">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="banner-content-wrapper">
              <div class="banner-content">
                <h2>contact</h2>
                <div class="banner-breadcrumb">
                  <ul>
                    <li>
                      <a href="/">home </a>
                      <i class="zmdi zmdi-chevron-right"></i>
                    </li>
                    <li>contact</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Banner Area End -->
    <!-- Contact Area Start -->
    <div class="contact-area pt-95 pb-100">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="contact-form section-title text-center">
              <h2 class="pb-5">Contact Form</h2>
              <div class="row">
                <form id="contact-form-two" action="mail.php" method="post">
                  <div class="col-sm-6">
                    <input
                      class="mb-30"
                      placeholder="Name"
                      name="name"
                      type="text"
                    />
                  </div>
                  <div class="col-sm-6">
                    <input
                      class="mb-30"
                      placeholder="Email"
                      name="email"
                      type="text"
                    />
                  </div>
                  <div class="col-sm-12">
                    <textarea
                      class="mb-30"
                      cols="30"
                      rows="7"
                      name="message"
                      placeholder="subject"
                    ></textarea>
                    <button type="submit">submit</button>
                  </div>
                </form>
                <p class="form-messege-two"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Contact Area End -->
  </main>
</template>

<script>
import constants from "../modules/constants";
export default {
  data: () => {
    return {
      mapStyle: {
        mapTypeControl: false,
        zoomControl: false,
        styles: [
          { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f5f5" }]
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }]
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#eeeeee" }]
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#d8ebd4" }]
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }]
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }]
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }]
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }]
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#cedfe0" }]
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }]
          }
        ]
      },
      form: {
        email: "",
        name: "",
        company: "",
        message: ""
      },
      show: true,
      sent: false,
      error: null
    };
  },
  methods: {
    validate() {
      this.error = null;
      if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
          this.form.email
        )
      ) {
        this.error = constants.errors.fill_fields["auth/invalid-email"];
      }
      if (
        !(
          this.form.email &&
          this.form.name &&
          this.form.company &&
          this.form.message
        )
      ) {
        this.error = constants.errors.fill_fields;
      }
      if (
        this.form.email.trim().length === 0 ||
        this.form.name.trim().length === 0 ||
        this.form.company.trim().length === 0 ||
        this.form.message.trim().length === 0
      ) {
        this.error = constants.errors.fill_fields;
      }
      setTimeout(() => {
        this.error = null;
      }, 3000);
    },
    onSubmit(event) {
      event.preventDefault();
      this.validate();
      if (!this.show) return;
      if (this.error) return;
      this.show = false;
      const formData = new FormData();
      formData.append("email", this.form.email);
      formData.append("name", this.form.name);
      formData.append("company", this.form.company);
      formData.append("message", this.form.message);
      fetch(constants.urls.apiContact, {
        method: "POST",
        mode: "cors",
        body: formData
      })
        .then(response => response.json())
        .then(json => {
          if (json.success !== true) {
            this.error = "An error occurred in sending your form";
          }
          this.form.email = "";
          this.form.name = "";
          this.form.company = "";
          this.form.message = "";
          this.show = true;
          this.sent = true;
          setTimeout(() => {
            this.sent = false;
          }, 5000);
        })
        .catch(() => {
          this.error = "An error occurred in sending your form";
          this.show = true;
        });
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
#content {
  position: relative;
}
.bg-map {
  position: absolute;
  left: 0;
  right: 0;
  top: -3rem;
  bottom: -3rem;
  z-index: 0;
}
.high-zindex {
  position: relative;
  z-index: 1;
}
</style>
<style>
.artibot-wrapper--19YJW {
  display: show;
}
</style>
